import {
  Handshake,
  Contact,
  Database,
  ChartLine,
  Building2,
  Map,
  ListChecks,
  Palette,
  LogOut,
  User,
  Plus,
  ArrowRightLeft,
  Megaphone,
  Bell,
  Users,
  Settings,
  ChevronDown,
} from 'lucide-angular';

export const AppIcons = {
  Handshake,
  Contact,
  Database,
  ChartLine,
  Building2,
  Map,
  ListChecks,
  Palette,
  LogOut,
  User,
  Plus,
  ArrowRightLeft,
  Megaphone,
  Bell,
  Settings,
  Users,
  ChevronDown,
};
